import DefaultLayout from '##/Default';
import UnitTypesView from './UnitTypesView';
import UnitTypesPricing from './UnitTypesPricing';


const routes = [
    {
        path: '/unit-types/:property_id?',
        exact: true,
        layout: DefaultLayout,
        component: UnitTypesView,
        auth: true,
        title: 'Unit Types'
    },
    {
        path: '/unit-types/:property_id?/pricing',
        exact: true,
        layout: DefaultLayout,
        component: UnitTypesPricing,
        auth: true,
        title: 'Unit Types Pricing'
    }
];

export default routes;
